import MonitoringManageView from "./MonitoringManageView";

const MonitoringManageWrapper = () => {
  return <MonitoringManageView />;
};
export default MonitoringManageWrapper;
